(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-carousel"] && !Shopify.designMode) return;
  try {
    
class CarouselBanner extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.viewport = this.querySelector('.cb__viewport');
    this.track = this.querySelector('.cb__track');
    this.slides = Array.from(this.querySelectorAll('.cb__slide'));
    this.dots = Array.from(this.querySelectorAll('.cb__dot'));
    this.prevBtn = this.querySelector('.cb__arrow--prev');
    this.nextBtn = this.querySelector('.cb__arrow--next');

    this.count = this.slides.length;
    this.index = 0;
    this.fade = this.dataset.transition === 'fade';
    this.loop = this.dataset.loop === 'true';
    this.wantsAutoplay = this.dataset.autoplay === 'true';
    this.speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.editor = typeof Shopify !== 'undefined' && Shopify.designMode;

    if (this.count <= 1) return;

    this.onPrev = () => { this.userPause(); this.prev(); };
    this.onNext = () => { this.userPause(); this.next(); };
    if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
    if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.userPause();
        this.goTo(parseInt(dot.dataset.index, 10));
      });
    });

    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { this.userPause(); this.prev(); }
      if (e.key === 'ArrowRight') { this.userPause(); this.next(); }
    });

    this.bindSwipe();
    this.bindHoverFocus();

    document.addEventListener('visibilitychange', () => {
      document.hidden ? this.stop() : this.maybeStart();
    });

    this.onResize = this.debounce(() => this.goTo(this.index, false), 150);
    window.addEventListener('resize', this.onResize);

    if (this.editor) this.bindEditor();

    this.goTo(0, false);
    this.maybeStart();
  }

  goTo(i, animate = true) {
    if (this.loop) {
      this.index = (i + this.count) % this.count;
    } else {
      this.index = Math.max(0, Math.min(i, this.count - 1));
    }

    if (this.fade) {
      this.slides.forEach((s, k) => {
        const on = k === this.index;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
    } else {
      const offset = this.slides[this.index].offsetLeft;
      this.track.style.transition = animate ? '' : 'none';
      this.track.style.transform = 'translateX(' + -offset + 'px)';
      if (!animate) requestAnimationFrame(() => { this.track.style.transition = ''; });
      this.slides.forEach((s, k) => {
        s.setAttribute('aria-hidden', k === this.index ? 'false' : 'true');
      });
    }

    this.dots.forEach((d, k) => {
      const on = k === this.index;
      d.classList.toggle('is-active', on);
      d.setAttribute('aria-current', on ? 'true' : 'false');
    });

    if (!this.loop) {
      if (this.prevBtn) this.prevBtn.disabled = this.index === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.index === this.count - 1;
    }
  }

  next() { this.goTo(this.index + 1); }
  prev() { this.goTo(this.index - 1); }

  maybeStart() {
    if (this.wantsAutoplay && !this.reduced && !this.editor && !this.paused) this.start();
  }
  start() {
    this.stop();
    this.timer = setInterval(() => {
      if (!this.loop && this.index === this.count - 1) { this.goTo(0); return; }
      this.next();
    }, this.speed);
  }
  stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
  userPause() { this.paused = true; this.stop(); }

  bindHoverFocus() {
    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => { if (!this.paused) this.maybeStart(); });
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => { if (!this.paused && !this.contains(document.activeElement)) this.maybeStart(); });
  }

  bindSwipe() {
    let startX = 0;
    let active = false;
    const threshold = 40;
    this.viewport.addEventListener('pointerdown', (e) => { startX = e.clientX; active = true; });
    this.viewport.addEventListener('pointerup', (e) => {
      if (!active) return;
      active = false;
      const dx = e.clientX - startX;
      if (Math.abs(dx) < threshold) return;
      this.userPause();
      dx < 0 ? this.next() : this.prev();
    });
    this.viewport.addEventListener('pointercancel', () => { active = false; });
  }

  bindEditor() {
    document.addEventListener('shopify:block:select', (e) => {
      const slide = this.slides.find((s) => s.dataset.blockId === e.detail.blockId);
      if (!slide) return;
      this.stop();
      this.paused = true;
      this.goTo(this.slides.indexOf(slide));
    });
    document.addEventListener('shopify:block:deselect', (e) => {
      const owns = this.slides.some((s) => s.dataset.blockId === e.detail.blockId);
      if (owns) this.paused = false;
    });
  }

  debounce(fn, wait) {
    let t;
    return (...a) => { clearTimeout(t); t = setTimeout(() => fn.apply(this, a), wait); };
  }

  disconnectedCallback() {
    this.stop();
    if (this.onResize) window.removeEventListener('resize', this.onResize);
  }
}
if (!customElements.get('carousel-banner')) {
  customElements.define('carousel-banner', CarouselBanner);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chbe-coming-soon"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Countdown Timer
    const dateString = "{{ section.settings.launch_date }}";
    let launchDate = new Date(dateString).getTime();
    
    if (isNaN(launchDate)) {
      launchDate = new Date(dateString + "Z").getTime();
    }
    
    if (isNaN(launchDate)) {
      console.warn("Invalid launch date format. Using default: 2025-10-30T00:00:00");
      launchDate = new Date("2025-10-30T00:00:00").getTime();
    }

    function updateCountdown() {
      const now = new Date().getTime();
      const distance = launchDate - now;

      const days = Math.max(0, Math.floor(distance / (1000 * 60 * 60 * 24)) || 0);
      const hours = Math.max(0, Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) || 0);
      const minutes = Math.max(0, Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)) || 0);
      const seconds = Math.max(0, Math.floor((distance % (1000 * 60)) / 1000) || 0);

      const daysEl = document.getElementById("chbeDays");
      const hoursEl = document.getElementById("chbeHours");
      const minutesEl = document.getElementById("chbeMinutes");
      const secondsEl = document.getElementById("chbeSeconds");
      
      if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');

      if (distance < 0) {
        clearInterval(countdownTimer);
        const countdownEl = document.getElementById("chbeCountdown");
        if (countdownEl) {        }
      }
    }

    let countdownTimer = setInterval(updateCountdown, 1000);
    updateCountdown();

    // Form Submission with improved feedback
    const formEl = document.getElementById('chbeNotifyForm');
    const successEl = document.getElementById('chbeSuccessMessage');
    const loadingEl = document.getElementById('chbeLoadingMessage');
    const gasIframe = document.getElementById('gas_iframe');
    const nonceEl = document.getElementById('chbeNonce');
    const submitBtn = formEl ? formEl.querySelector('button[type="submit"]') : null;

    if (formEl && gasIframe && nonceEl && submitBtn) {
      let timer = null;
      let currentNonce = null;

      function setSending() {
        clearTimeout(timer);
        successEl.classList.remove('show');
        loadingEl.classList.add('show');
        submitBtn.disabled = true;
      }

      function setSuccess() {
        clearTimeout(timer);
        loadingEl.classList.remove('show');
        submitBtn.disabled = false;
        formEl.reset();
        successEl.classList.add('show');
        setTimeout(() => successEl.classList.remove('show'), 5000);
      }

      function setError(txt) {
        clearTimeout(timer);
        loadingEl.classList.remove('show');
        submitBtn.disabled = false;
        console.error('Submit error:', txt);
        alert('تعذّر التسجيل' + (txt ? (': ' + txt) : ''));
      }

      // Listen for postMessage from iframe
      window.addEventListener('message', (ev) => {
        if (ev.source !== gasIframe.contentWindow) return;
        const data = ev.data || {};
        
        if (data.type === 'GAS_LEAD_OK' && data.nonce && data.nonce === currentNonce) {
          setSuccess();
        } else if (data.type === 'GAS_LEAD_ERR') {
          setError(data.error);
        }
      }, { passive: true });

      // Prevent confusing initial iframe loads
      try { gasIframe.src = 'about:blank'; } catch(_) {}

      // Handle form submission
      formEl.addEventListener('submit', () => {
        // Generate unique nonce for this submission
        currentNonce = Date.now().toString(36) + Math.random().toString(36).slice(2);
        nonceEl.value = currentNonce;

        setSending();

        // Fallback: Show success after 3 seconds if no postMessage received
        timer = setTimeout(() => {
          console.warn('Fallback success: postMessage timeout');
          setSuccess();
        }, 3000);
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
